import { useMemo } from 'react';
import { useNavigate as useRouterNavigate } from 'react-router-dom'
export const useNavigate = (...props) => {
    const navigate = useRouterNavigate(...props);

    return useMemo(() => (...args) => {
        if (args.length !== 2 || typeof args?.[0] !== 'string') {
            navigate(...args);
            return;
        }
        if (args[1] && (!args[1].target || args[1].target === '_self')) {
            navigate(...args);
            return;
        }
        const baseURL = (process.env.NODE_ENV === 'production' ? '/ora' : '');
        let path = baseURL + args[0]
        if (!args[0].startsWith('/')) {
            path = window.location.pathname + '/' + args[0];
        }
        window.open(path, args[1].target);
    }, [navigate])
}